const baseUrl = '/api/1.0';

// use full url if protocol included
const getUrl = (url: string = ''): string => (
  url.includes('://')
    ? url
    : `${baseUrl}${url}`
);

// deep object nesting
const serialize = (root: any, nestedPrefix?: string): string => (
  root && Object
    .keys(root)
    .reduce((a: string[], key: string) => {
      const value = root[key];
      const prefix = nestedPrefix ? `${nestedPrefix}[${key}]` : key;
      const newItems: string|string[] = typeof value === 'object'
        ? serialize(value, prefix)
        : [`${encodeURIComponent(prefix)}=${encodeURIComponent(value)}`];
      return a.concat(newItems);
    }, [])
    .join('&')
);

// parse JSON response and reject if status not valid
const responseHandler = <ResponsePayload>(
  response: Response,
): Promise<ResponsePayload> => (
  response.ok
    ? response.text().then(text => (
        text && text.length
          ? JSON.parse(text)
          : text
      ))
    : response
      .json()
      .then(body => Promise.reject(body))
);

const get = <ResponsePayload>(url: string = '', params: any) => {
  const qs = params ? `?${serialize(params)}` : '';
  const fullUrl = `${getUrl(url)}${qs}`;
  return fetch(fullUrl, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
  .then(response => responseHandler<ResponsePayload>(response));
};

interface Opts {
  headers?: {
    [key: string]: string;
  };
}

const PutPost = (method: string) => <ResponsePayload>(
  url: string,
  body: any = {},
  opts: Opts = {},
)  => {
  const isNotJson = opts.headers && opts.headers['Content-Type'] !== 'application/json';
  const bodyContent = isNotJson ? body : JSON.stringify(body);
  return fetch(getUrl(url), {
    body: bodyContent,
    method,
    headers: {
      'Content-Type': 'application/json',
      ...opts.headers,
    },
  })
  .then(response => responseHandler<ResponsePayload>(response));
};

const post = PutPost('post');

const put = PutPost('put');

export default {
  get,
  post,
  put,
};
